import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, deleteDataList, getData, getPostData, patchData, postData } from "src/utils/axios/serverHelper";

import { MST7020_R01Dto } from "./Dto_MST7020_R01";
import { MST7020_R01Filter } from "./Store_MST7020_R01";
import { PopbillResponseDto } from "src/dtos/common/popbillResponseDto";
import { PopbillRequestDto } from "src/dtos/common/popbillRequestDto";
import { formatDateYYYYMMDD } from "src/utils/string/stringUtil";

const baseUrl = `${config.popbillUrl}/cellPhoneMail/message`;

export const getMST7020_R01List = async (option: string, params: Partial<MST7020_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/popbillList`

    console.log(config.popbillUrl);

	const sdate = formatDateYYYYMMDD(params.dateRange?.from);
	const edate = formatDateYYYYMMDD(params.dateRange?.to);

	const requestParams: PopbillRequestDto = {
		corpNum: config.popbill_CorpNum ?? '',
		userID: config.popbill_UserId ?? '',
		listLength: listLength ?? 0,
		sdate: sdate,
		edate: edate,
		...params
	}

	// console.log('requestParams : ', requestParams);

    return await getPostData<PopbillRequestDto, PopbillResponseDto<MST7020_R01Dto>>(url, requestParams);
}

export const getMST7020_R01AllCount = async (params: Partial<MST7020_R01Filter>) => {
    const url = `${baseUrl}/popbillList/allCount`;

	const sdate = formatDateYYYYMMDD(params.dateRange?.from);
	const edate = formatDateYYYYMMDD(params.dateRange?.to);
	
	const requestParams: PopbillRequestDto = {
		corpNum: config.popbill_CorpNum ?? '',
		userID: config.popbill_UserId ?? '',
		listLength: 0,
		sdate: sdate,
		edate: edate,
		...params
	}

    return await getPostData<PopbillRequestDto, PopbillResponseDto<MST7020_R01Dto>>(url, requestParams);
}

//전송
export const postMST7020_R01 = async (data: MST7020_R01Dto[], sendType: 'short' | 'long', reserveType: 'reserve' | 'direct') => {

    const requestParams: PopbillRequestDto = {
        corpNum: config.popbill_CorpNum ?? '',
        userID: config.popbill_UserId ?? '',
        listLength: data.length,
        sdate: '',
        edate: '',
        cmailArray: data,
    }

    const url = `${baseUrl}/${sendType}/${reserveType}`;

    return await postData<PopbillRequestDto, PopbillResponseDto<MST7020_R01Dto>>(url, requestParams);
}

//예약문자 수정
export const patchMST7020_R01 = async (data: MST7020_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<MST7020_R01Dto[], PopbillResponseDto<MST7020_R01Dto>>(url, data);
}

//예약문자 취소 - patch 사용
export const deleteMST7020_R01 = async (data: MST7020_R01Dto[]) => {
    const url = `${baseUrl}/cancel`;

	
    const requestParams: PopbillRequestDto = {
        corpNum: config.popbill_CorpNum ?? '',
        userID: config.popbill_UserId ?? '',
        listLength: data.length,
        sdate: '',
        edate: '',
        cmailArray: data,
    }

    return await patchData<PopbillRequestDto, PopbillResponseDto<MST7020_R01Dto>>(url, requestParams);
}

//엑셀출력 - 안함
export const downloadExcel_MST7020_R01 = async (option: string, params: Partial<MST7020_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/popbillList/excel`

    return await getData<ResponseDto<string>>(url, {
        params: { 
			corpNum: config.popbill_CorpNum,
			userID: config.popbill_UserId,
            ...params,
            listLength: listLength ?? 0 
        }
    });
}